import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";

export const prettyPrintWasteClassification = (
  classification: string | null | undefined
): string => {
  if (!classification) return "";
  return prettyPrintEnumValue(classification)?.replace("Rcra", "RCRA") ?? "";
};
